/**
 * Electronic invoice (CFE) domain model. No DB, no XML, no DGI integration.
 * Structure aligned with docs/ Formato_CFE and XSDs (Encabezado, Detalle, Totales).
 */
/** Credit Note types: 102, 112, 122, 132/142 (Cuenta Ajena), 152 (e-Boleta de entrada). */
const CREDIT_NOTE_TYPES = new Set(['102', '112', '122', '132', '142', '152']);
/** Debit Note types: 103, 113, 123, 133/143 (Cuenta Ajena), 153 (e-Boleta de entrada). */
const DEBIT_NOTE_TYPES = new Set(['103', '113', '123', '133', '143', '153']);
/** Base invoice types that can be referenced by NC/ND: 101, 111, 121, 131, 141, 151 (e-Boleta de entrada). */
const BASE_INVOICE_TYPES = new Set(['101', '111', '121', '131', '141', '151']);
/** Export invoice and note types: 121, 122, 123 (e-Factura Exportación). */
export const EXPORT_CFE_TYPES = new Set(['121', '122', '123']);
export function isCreditNote(cfeType) {
    return CREDIT_NOTE_TYPES.has(cfeType);
}
export function isDebitNote(cfeType) {
    return DEBIT_NOTE_TYPES.has(cfeType);
}
export function canReference(cfeType) {
    return isCreditNote(cfeType) || isDebitNote(cfeType);
}
export function isBaseInvoiceType(cfeType) {
    return BASE_INVOICE_TYPES.has(cfeType);
}
export function isExportInvoiceType(cfeType) {
    return EXPORT_CFE_TYPES.has(cfeType);
}
/** Returns the CFE type that a Credit Note references (102→101, 112→111, 122→121, 132→131, 142→141). */
export function getReferencedCfeTypeForCredit(cfeType) {
    if (cfeType === '102')
        return '101';
    if (cfeType === '112')
        return '111';
    if (cfeType === '122')
        return '121';
    if (cfeType === '132')
        return '131';
    if (cfeType === '142')
        return '141';
    if (cfeType === '152')
        return '151';
    return null;
}
/** Returns the CFE type that a Debit Note references (103→101, 113→111, 123→121, 133→131, 143→141). */
export function getReferencedCfeTypeForDebit(cfeType) {
    if (cfeType === '103')
        return '101';
    if (cfeType === '113')
        return '111';
    if (cfeType === '123')
        return '121';
    if (cfeType === '133')
        return '131';
    if (cfeType === '143')
        return '141';
    if (cfeType === '153')
        return '151';
    return null;
}
